module.exports = __webpack_public_path__ + "img/wordpress-black.d49a7056.png";